import { useState, useRef, useEffect, useCallback } from "react";
import { useHistory } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import { useForm, Controller } from "react-hook-form";

import TextField from "@mui/material/TextField";

// components
import { Knob } from "react-rotary-knob";
import { IconButton, Button, Slider } from "@mui/material";
import * as skins from "react-rotary-knob-skin-pack";
import Container from "@material-ui/core/Container";
import LayerControler from "components/layerControler";
import VocalControl from "components/vocalControler";
import WaveMonitor from "components/Portrait/components/WaveMonitor";
import LEDButton from "components/shared/LEDButton";
import LoginModal from "components/Portrait/components/LoginModal";
import UpDownButton from "components/shared/UpDownButton";

// import {
//   Magnifier,
//   GlassMagnifier,
//   SideBySideMagnifier,
//   PictureInPictureMagnifier,
//   MOUSE_ACTIVATION,
//   TOUCH_ACTIVATION
// } from "react-image-magnifiers";

import GlassMagnifier from "components/MagnifierGlass/GlassMagnifier";

import imageNumbers from "assets/images/numbers";
// import SwipeableViews from "react-swipeable-views";
import SwipeableViews from "components/shared/SwipableViews/SwipeableViews";

import ENkeyboardBaseImage from "assets/phase2/keyboard/keyboard_en_500.png";
import ENkeyboardLargeImage from "assets/phase2/keyboard/keyboard_en_1000.png";

import FAKeyboardBaseImage from "assets/phase2/keyboard/keyboard_fa_500.png";
import FAKeyboardLargeImage from "assets/phase2/keyboard/keyboard_fa_1000.png";

import Grid from "@material-ui/core/Grid";
import Input from "components/shared/Input";
import LoadingButton from "components/shared/LoadingButton";
import Typography from "components/shared/Typography";

//icons

import PlayIcon from "@mui/icons-material/PlayArrow";
import PauseIcon from "@mui/icons-material/Pause";
import StopIcon from "@mui/icons-material/Stop";

// assets
import seekerKnobSkin from "assets/knobSkins/seeker";
import playbackSpeedKnob from "assets/knobSkins/skin12";
import nameImage from "assets/images/name.png";
import leftBack from "assets/phase2/left.png";
import middleBack from "assets/phase2/middle.png";
import rightBack from "assets/phase2/right.png";
// import leftBack from "assets/images/leftBack.png";
// import middleBack from "assets/images/middleBack.png";
// import rightBack from "assets/images/rightBack.png";
import trackNumberSVG from "assets/images/trackNumber.svg";
import numbersSVG from "assets/images/trackNumber.svg";

import pitchBand from "assets/phase2/7.png";
import exportBtn from "assets/phase2/9.png";
import resetBtn from "assets/phase2/10.png";

import albumArt from "assets/images/jahanam_art.png";
import freqSlider from "assets/phase2/79.png";

import prevButton from "assets/images/prev_btn.png";
import playButton from "assets/images/play_btn.png";
import pauseButton from "assets/images/pause_btn.png";
import nextButton from "assets/images/next_btn.png";

import tempoControlBack from "assets/phase2/8.png";

// import vocalTrack from "assets/sounds/eeham/vocals.mp3";
// import drumTrack from "assets/sounds/eeham/drums.mp3";
// import bassTrack from "assets/sounds/eeham/bass.mp3";
// import instrumentTrack from "assets/sounds/eeham/other.mp3";

// constants
import { SPACING, SPACING_THIRD } from "constants/spacing";

// hooks
// import { useLogin } from "hooks/auth";
import { useUserState } from "providers/UserProvider";

// lib
import {
  getAuthCookie,
  setAuthCookie,
  setNavigationInStorage,
  setUserInStorage,
} from "lib/Storage";
import volume from "assets/knobSkins/volume";
import volumeJust from "assets/knobSkins/volumeJust";
import { Avatar } from "@material-ui/core";
import Control from "components/Control";
// import UniversalControler from "components/universalControlerSeprated";
import UniversalControler from "components/universalControlerClass";
import Dialpad from "components/Dialpad/Dialpad";
import { getComputedValue } from "utils";

const useStyles = makeStyles((theme) => ({
  // root: {
  //   width: "100%",
  //   height: "100%",

  //   justifyContent: "center",
  //   // backgroundImage: `url(${background})`,
  //   backgroundSize: "contain",
  //   backgroundRepeat: "no-repeat",
  //   position: "relative",
  //   paddingLeft: "14%",
  //   paddingRight: "14%",
  //   paddingTop: "11.5%",
  //   paddingBottom: "44.75%" /* 16:9 */,
  // },
  gridRoot: {
    position: "absolute",
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    color: "white",
    textAlign: "center",
    background: "green",
  },
  gridItems: {
    // backgroundColor:"blue",
    height: "100%",
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
  },
  gridColumn: {
    height: "34vw",
  },
  playbackSpeedKnob: {
    display: "inline-block",
    width: "100%",
  },
  mainContainer: {
    width: "100%",
    height: "100%",
    position: "relative",
    color: "black",
    textAlign: "center",
  },
  layerControlContainer: {
    width: "30%",
    background: "red",
  },
  LEDButtonContainer: {
    width: "60%",
    height: "70%",
    position: "relative",
    top: "30%",
    left: "5%",
    display: "inline-flex",
  },
  playbackControlContainer: {
    position: "relative",
    // top: "-55%",
    // left: "29%",
    height: "100%",
    display: "flex",
    zIndex: 11,
  },
  controlButtons: {
    width: "30%",
    height: "100%",
    margin: "1vw",
  },
  progressContainer: {
    position: "relative",
    height: "100%",
    width: "100%",

    justifyContent: "center",
    display: "flex",
  },

  textureContainer: {
    position: "relative",
    width: "100%",
    height: "100%",
    backgroundImage: `url(${numbersSVG})`,
    backgroundSize: "100% auto",
    backgroundRepeat: "no-repeat",
  },
  //spacerDivs:
  leftSpacerDiv: {
    width: "100%",
    height: "31%",
  },
  middleSpacerDiv: {
    width: "100%",
    height: "24%",
    // background: "rgba(0,255,0,0.4)",
  },
  //
  LeftPortraitContainer: {
    // position: "relative",
    top: "0px",
    width: "100%",
    height: "1080px",
    // maxHeight: "1651px",
    // maxWidth: "774px",
    backgroundImage: `url(${leftBack})`,
    backgroundSize: "100% auto",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "right bottom",
    // paddingTop:"65%",
    overflow: "hidden",
    // paddingLeft:"10%",
    // paddingRight:"10%"
  },
  MiddlePortraitContainer: {
    width: "100%",
    height: "1080px",
    top: "0px",
    position: "relative",
    // maxHeight: "1651px",
    // maxWidth: "774px",
    backgroundImage: `url(${middleBack})`,
    backgroundSize: "100% auto",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center bottom",
    // paddingTop: "67%",
    // paddingBottom: "10%",
    overflow: "hidden",
  },
  RightProtraitContainer: {
    width: "100%",
    height: "1080px",
    position: "relative",
    top: "0px",
    // maxHeight: "1651px",
    // maxWidth: "774px",
    backgroundImage: `url(${rightBack})`,
    backgroundSize: "100% auto",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "left bottom",
    // paddingTop: "67%",

    paddingBottom: "6%",
    overflow: "hidden",
  },
  topDotDisplay: {
    width: "100%",
    height: "12%",
    // backgroundColor:"#00ff0077"
  },
  controlers: {
    width: "100%",
    position: "relative",
    // height: "43.5%",
    height: "59%",
  },
  pitchBand: {
    width: "75%",
    height: "60%",
    position: "relative",
    top: "30%",
    left: "12%",
    backgroundSize: "100% auto",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    backgroundImage: `url(${pitchBand})`,
  },
  topLayerBotton: {
    width: "80%",
    height: "35%",
    // backgroundColor: "#55ff3388",
    top: "10%",
    left: "10%",
    position: "relative",
    backgroundSize: "100% auto",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center bottom",
  },
  filterBox: {
    width: "100%",
    height: "15%",
    // backgroundColor: "#00ff0040",
  },
  recorder: {
    width: "100%",
    height: "29%",
    // backgroundColor: "#0000ff40",
  },
  loginModal: {},
}));

const freqMarks = [
  {
    value: 0,
    // label: "Family",
  },
  {
    value: 16.66666,
    // label: "OFFICIAL",
  },
  {
    value: 16.66666 * 2 + 0.1,
    // label: "ORIGINAL",
  },
  {
    value: 16.66666 * 3 - 0.3,
    // label: "DIRTY",
  },
  {
    value: 16.66666 * 4,
    // label: "CHAT",
  },
  {
    value: 16.66666 * 5 - 0.19,
    // label: "PRIVATE",
  },
  {
    value: 100 - 0.1,
    // label: "*",
  },
];

/**
 * @component Base
 */
function Base(props) {
  const { audioContextInstance } = props;
  const classes = useStyles();
  const leftContainerRef = useRef(null);
  const [user, setUser] = useUserState();
  const [currentTrack, setCurrentTrack] = useState(1);
  const [frequency, setFrequency] = useState("");
  const [password, setPassword] = useState("");
  const [selectedLetter, setSelectedLetter] = useState("");

  const [blinkingCursor, setBlinkingCursor] = useState(false);
  const [currentTypingFocus, setCurrentTypingFocus] = useState("frequency");

  // const mediaMatch = window.matchMedia("(max-width: 1000px)");
  // const [matches, setMatches] = useState(mediaMatch.matches);

  // const audioContextInstance =

  // useEffect(() => {
  //   const handler = (e) => setMatches(e.matches);
  //   mediaMatch.addListener(handler);
  //   return () => mediaMatch.removeListener(handler);
  // });
  const keyboardRef = useRef(null);

  const percentOfHeight = (percent) =>
    `${Math.floor(
      containersHeight * (percent / 100)
    )}px`;
  const percentOfWidth = (percent) => {
    return `${Math.floor(
      leftContainerRef?.current?.offsetWidth * (percent / 100)
    )}px`;
  };

  // useEffect(() => {
  //   if(!leftContainerRef?.current?.offsetWidth && !leftContainerRef?.current?.offsetHeight) return;
  //   console.log("useEffect called!!!")
  //   percentOfHeight = (percent)=> `${leftContainerRef?.current?.offsetHeight * (percent / 100)}px`;
  //   percentOfWidth = (percent) => `${leftContainerRef?.current?.offsetWidth * (percent / 100)}px`;
  // }, [leftContainerRef?.current?.offsetWidth,leftContainerRef?.current?.offsetHeight]);

  let hadelKeyboardSubmit = () => {
    console.log("external Handler, selectedLetter is:", selectedLetter);
    setPassword((password) => password + selectedLetter);
  };

  useEffect(
    (s) => {
      hadelKeyboardSubmit = () => {
        setPassword((password) => password + selectedLetter);
      };
    },
    [selectedLetter]
  );

  // blinking Cursor
  useEffect(() => {
    const blinkingCursorInterval = setInterval(() => {
      setBlinkingCursor((current) => !current);
    }, 500);

    return () => {
      clearInterval(blinkingCursorInterval);
    };
  }, []);

  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm({ defaultValues: { username: "", password: "" } });
  // const { mutate, isLoading } = useLogin();
  const history = useHistory();

  const folder = "lalaee";
  const layerTemplate = {
    volume: 1,
    panning: 0,
    muted: false,
    audioElement: null,
    audioContext: null,
    panner: null,
  };

  // console.log(audioContextInstance)
  const webAudioOutput = audioContextInstance.createGain();

  const compressor = audioContextInstance.createDynamicsCompressor();
  compressor.threshold.setValueAtTime(-50, audioContextInstance.currentTime);
  compressor.knee.setValueAtTime(40, audioContextInstance.currentTime);
  compressor.ratio.setValueAtTime(12, audioContextInstance.currentTime);
  compressor.attack.setValueAtTime(0, audioContextInstance.currentTime);
  compressor.release.setValueAtTime(0.25, audioContextInstance.currentTime);

  const mergerNode = audioContextInstance.createChannelMerger(4);

  const [layers, setLayers] = useState({
    layer1: {
      ref: useRef(),
      ledRef: useRef(),
      id: "layer1",
      type: "vocal",
      name: "vocal",
      layerNumber: 0,
      layerPosition: 0,
      localParametes: {
        ...layerTemplate,
        // url: `sounds/ebi/vocals.mp3`,
        // url: `sounds/lalaee/vocals.mp3`,
        // url: `${vocalTrack}`,
        url: "https://fs.shegeftangizan.com/timeline-smart-tailless/04%20Be%20Joz%20Eshgh%20-%20Vocal%20.mp3",
        // url: "assets/sounds/benyamin/vocals.mp3",
      },
    },
    layer2: {
      ref: useRef(),
      ledRef: useRef(),
      id: "layer2",
      name: "drums",
      layerNumber: 1,
      layerPosition: 2,
      localParametes: {
        ...layerTemplate,
        // url: "assets/sounds/ebi/drums.mp3",
        // url: "assets/sounds/lalaee/drums.mp3",
        // url: `${drumTrack}`,
        url: "https://fs.shegeftangizan.com/timeline-smart-tailless/04%20Be%20Joz%20Eshgh%20-%20Drums.mp3",
        // url: "assets/sounds/benyamin/drums.mp3",
      },
    },
    layer3: {
      ref: useRef(),
      ledRef: useRef(),
      id: "layer3",
      name: "inst",
      layerNumber: 2,
      layerPosition: 4,
      localParametes: {
        ...layerTemplate,
        // url: "assets/sounds/ebi/bass.mp3",
        // url: "assets/sounds/lalaee/bass.mp3",
        // url: `${bassTrack}`,
        url: "https://fs.shegeftangizan.com/timeline-smart-tailless/04%20Be%20Joz%20Eshgh%20-%20Back%20Vocal%20.mp3",
        // url: "assets/sounds/benyamin/bass.mp3",
      },
    },
    layer4: {
      ref: useRef(),
      ledRef: useRef(),
      id: "layer4",
      name: "BV",
      layerNumber: 3,
      layerPosition: 1,
      localParametes: {
        ...layerTemplate,
        // url: "assets/sounds/ebi/other.mp3",
        // url: "assets/sounds/lalaee/other.mp3",
        // url: `${instrumentTrack}`,
        url: "https://fs.shegeftangizan.com/timeline-smart-tailless/04%20Be%20Joz%20Eshgh%20-%20Instrument%20.mp3",
        // url: "assets/sounds/benyamin/other.mp3",
      },
    },
    layer5: {
      ref: useRef(),
      ledRef: useRef(),
      id: "Base",
      name: "Base",
      layerNumber: 4,
      layerPosition: 3,
      isDecorative: true,
      localParametes: {
        ...layerTemplate,
        // url: "assets/sounds/ebi/other.mp3",
        // url: "assets/sounds/lalaee/other.mp3",
        // url: `${instrumentTrack}`,
        url: "",
        // url: "assets/sounds/benyamin/other.mp3",
      },
    },
  });

  const [playState, setPlayState] = useState("stopped");
  const [playbackSpeed, setPlaybackSpeed] = useState(1);
  const [tempo, setTempo] = useState(120);
  const [transpose, setTranspose] = useState(0);
  const [currentPortion, setCurrentPortion] = useState(0);
  const trackStates = {
    vocal: "",
    inst: "",
    drums: "",
    BV: "",
  };
  const [containersHeight, setContainersHeight] = useState(0);
  useEffect(() => {
    console.log(
      "width",
      leftContainerRef.current ? leftContainerRef.current.offsetWidth : 0
    );
    console.log(
      "computedHeight: ",
      leftContainerRef.current
        ? Math.floor((leftContainerRef.current.offsetWidth / 16) * 9 * 3)
        : 0
    );
    setContainersHeight(
      leftContainerRef.current
        ? Math.floor((leftContainerRef.current.offsetWidth / 16) * 9 * 3)
        : 0
    );
  }, [leftContainerRef?.current?.offsetWidth]);

  const handelMuteLayer = (layerName) => {
    layers[layerName].ref.current.toggleMute();
  };
  const handelMuteLED = (layerName) => {
    layers[layerName].ledRef.current.toggleMute();
  };
  const handelSoloSideEffects = (targetLayerName) => {
    for (let layerName of Object.keys(layers)) {
      if (layerName !== targetLayerName && !layers[layerName].isDecorative)
        layers[layerName].ref.current.setMute(true);
    }
  };

  const handelTempoChange = (newValue) => {
    let ratio = newValue / (tempo + 0.0);
    let newSpeed = playbackSpeed * ratio;
    console.log("newRatio:", ratio, newSpeed);

    for (let layer of Object.values(layers)) {
      if (layer?.ref?.current?.isDecorative) continue;
      layer?.ref?.current?.changePlaybackSpeed(newSpeed);
    }
    setTempo(newValue);
    setPlaybackSpeed((playbackSpeed) => playbackSpeed * ratio);
  };

  const handelTransposeChange = (newValue) => {
    // let currentTempo = tempo + changeValue;
    // let ratio = currentTempo / (tempo + 0.0);
    setTranspose(newValue);
    // setPlaybackSpeed((playbackSpeed) => playbackSpeed * ratio);
  };
  const handelSelection = (selectedLayerId) => {
    console.log("handelSelection called from:", selectedLayerId);
    for (let layer of Object.values(layers)) {
      if (layer?.ref?.current?.isDecorative) continue;
      if (layer.name !== selectedLayerId) layer?.ref?.current?.deselect();
    }
  };

  const handelKeyboardCallback = (selectedLetter) => {
    setCurrentTypingFocus("password");
    if (selectedLetter == "DEL") {
      setPassword(password.slice(0, -1));
    } else {
      setPassword((password) => password + selectedLetter);
    }
  };

  const handelPlay = () => {
    for (let layer of Object.values(layers)) {
      if (layer.isDecorative) continue;
      // console.log(layer.ref)
      layer.ref.current.play();
    }
    setPlayState("played");
  };
  const handelPause = () => {
    for (let layer of Object.values(layers)) {
      if (layer.isDecorative) continue;
      layer.ref.current.pause();
    }
    setPlayState("paused");
  };

  const handelStop = () => {
    for (let layer of Object.values(layers)) {
      if (layer.isDecorative) continue;
      layer.ref.current.stop();
    }
    setPlayState("stopped");
  };

  const changeState = (name, newState) => {
    if (newState === "waiting") {
      for (let layer of Object.values(layers)) {
        if (layer.isDecorative) continue;
        if (layer.name != name) trackStates[layer.name] = "readyToPlay";
        layer.ref.current.pause();
      }
    }
    trackStates[name] = newState;

    //check states
    let trackStateValues = Object.values(trackStates);
    if (
      trackStateValues.every((element) => element == "readyToPlay") &&
      playState == "waiting"
    ) {
      for (let layer of Object.values(layers)) {
        if (layer.isDecorative) continue;
        layer.ref.current.play();
      }
    }
    if (trackStateValues.every((element) => element == "ended")) {
      console.log("all has been ended");
      handelNextTrack();
      announceCurrentPortion(0);
    }
  };

  const announceCurrentPortion = (currentPortion) => {
    if (currentPortion >= 1) return;
    setCurrentPortion(currentPortion);
  };

  const handelNextTrack = () => {
    console.log("handel next track called! currentTrack is:", currentTrack);
    for (let layer of Object.values(layers)) {
      if (layer.isDecorative) continue;
      // console.log(layer.ref)
      trackStates[layer.name] = "";
      layer.ref.current.stop();
    }
    setCurrentTrack((currentTrack) => currentTrack + 1);
  };
  const handelPrevTrack = () => {
    for (let layer of Object.values(layers)) {
      if (layer.isDecorative) continue;
      trackStates[layer.name] = "";
      layer.ref.current.stop();
    }
    setCurrentTrack((currentTrack) => currentTrack - 1);
  };
  webAudioOutput.connect(compressor);
  compressor.connect(audioContextInstance.destination);

  return (
    <>
      <div className={classes.root}>
        <Grid
          container
          // index={2}

          style={{ display: "width:100%" }}
          // containerStyle={{ height: "100%" }}
          enableMouseEvents
          // resistance={true}
        >
          <Grid
            item
            xs={4}
            container
            ref={leftContainerRef}
            className={classes.LeftPortraitContainer}
            style={{
              height: `${containersHeight}px`,
              paddingTop: getComputedValue(containersHeight, 12),
              paddingBottom: getComputedValue(containersHeight, 4.5),
            }}
          >
            {/* <Grid item className={classes.leftSpacerDiv}></Grid> */}
            <Grid
              item
              className={classes.gridItems}
              style={{
                height: getComputedValue(containersHeight, 11),
                width: "100%",
                // backgroundColor: "#ff000050",
              }}
            ></Grid>

            <Grid
              item
              className={classes.gridItems}
              style={{
                height: getComputedValue(containersHeight, 17),
                width: "100%",
                position: "relative",
                // background: "#aaff0050",
              }}
            >
              {/* <WaveMonitor></WaveMonitor> */}
            </Grid>

            <Grid
              //spacer div
              item
              className={classes.gridItems}
              style={{
                height: getComputedValue(containersHeight, 4),
                width: "100%",
                // backgroundColor: "#00000050",
              }}
            ></Grid>

            <Grid
              item
              style={{
                height: getComputedValue(containersHeight, 48),
                width: "100%",
                position: "relative",
                // background: "#00ffff50",
              }}
            >
              <div
                className={classes.progressContainer}
                style={{
                  padding: `17% 22% 15% 27%`,
                }}
              >
                {/* <div className={classes.textureContainer}> */}
                <Knob
                  style={{
                    height: "100%",
                    width: "100%",
                    display: "inline-block",
                    // margin: "10px",
                    transform: "translate(1%, -7%)",
                    zIndex: 10,

                    // transform: "translate(-5%, -11%)",
                    "-webkit-transition": "-webkit-transform .5s ease-in-out",
                    "-ms-transition": "-ms-transform .5s ease-in-out",
                    transition: "transform .5s ease-in-out",
                  }}
                  skin={seekerKnobSkin}
                  min={0}
                  max={100}
                  step={1}
                  value={currentPortion * 100}
                  unlockDistance={50}
                  clampMin={0}
                  clampMax={240}
                  rotateDegrees={-120}
                  onChange={(value) => {
                    const maxDistance = 50;
                    let distance = Math.abs(value - currentPortion * 100);
                    if (distance > maxDistance) {
                      return;
                    } else {
                      for (let layer of Object.values(layers)) {
                        layer.ref.current.changeCurrentTime(value / 100);
                      }
                      setCurrentPortion(value / 100);
                    }
                  }}
                />
                {/* <div
                  style={{
                    height: "100vw",
                    width: "100vw",
                    padding: "5%",
                    position: "absolute",
                    top: 0,
                    left: 0,
                    bottom: 0,
                    right: 0,
                    display: "inline",
                    transform: `rotate(${-130 + (currentTrack - 1) * 14}deg)`,
                    "-webkit-transform": `-webkit-rotate(${
                      -130 + (currentTrack - 1) * 14
                    }deg)`,

                    // margin: "10px",
                    // transform: "translate(1%, -7%)",
                    // "-webkit-transform":"translate(1%,-7%)",
                    // transform: "translate(-5%, -11%)",
                  }}
                >
                  <img src={trackNumberSVG} />
                </div> */}
              </div>
            </Grid>

            <Grid
              item
              style={{
                height: getComputedValue(containersHeight, 3.5),
                width: "100%",
                // backgroundColor: "#ff00ff50",
              }}
            >
              <Grid container style={{ height: "100%" }}>
                <Grid item xs={3} className={classes.gridItems}></Grid>
                <Grid item xs={5} className={classes.gridItems}></Grid>
                <Grid item xs={3} className={classes.gridItems}>
                  <div className={classes.playbackControlContainer}>
                    <Avatar
                      className={classes.controlButtons}
                      style={{
                        margin: getComputedValue(
                          leftContainerRef?.current?.offsetWidth,
                          1
                        ),
                        width: getComputedValue(containersHeight, 3.5),
                        height: getComputedValue(containersHeight, 3.5),
                      }}
                      onClick={handelPrevTrack}
                      src={prevButton}
                    ></Avatar>
                    <Avatar
                      className={classes.controlButtons}
                      style={{
                        margin: getComputedValue(
                          leftContainerRef?.current?.offsetWidth,
                          1
                        ),
                        width: getComputedValue(containersHeight, 3.5),
                        height: getComputedValue(containersHeight, 3.5),
                      }}
                      onClick={playState == "played" ? handelPause : handelPlay}
                      src={playState == "played" ? pauseButton : playButton}
                    ></Avatar>
                    <Avatar
                      className={classes.controlButtons}
                      style={{
                        margin: getComputedValue(
                          leftContainerRef?.current?.offsetWidth,
                          1
                        ),
                        width: getComputedValue(containersHeight, 3.5),
                        height: getComputedValue(containersHeight, 3.5),
                      }}
                      src={nextButton}
                      onClick={handelNextTrack}
                    ></Avatar>
                  </div>
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          <Grid
            item
            xs={4}
            container
            direction="column"
            className={classes.MiddlePortraitContainer}
            style={{
              height: `${containersHeight}px`,
              paddingTop: `${containersHeight * 0.12}px`,
              paddingBottom: `${containersHeight * 0.06}px`,
            }}
          >
            <Grid
              item
              container
              direction="row"
              className={classes.topDotDisplay}
            >
              <Grid item xs={8} style={{ left: "-6%", position: "relative" }}>
                <img
                  src={albumArt}
                  style={{
                    width: "60%",
                    right: "0.35%",
                    top: "16%",
                    position: "absolute",
                  }}
                ></img>
              </Grid>
            </Grid>

            <Grid
              item
              container
              className={classes.controlers}
              style={{ display: "grid" }}
            >
              <UniversalControler
                playbackSpeed={playbackSpeed}
                layerId={layers["layer1"].id}
                layerNumber={layers["layer1"].layerNumber}
                layerPosition={layers["layer1"].layerPosition}
                mergerNodeReference={mergerNode}
                audioContextInstance={audioContextInstance}
                ref={layers["layer1"].ref}
                key={"vocal"}
                name={"vocal"}
                initialVolume={1}
                initialPanning={0}
                // selected
                // src={`https://fs.shegeftangizan.com/timeline-smart-tailless/${(
                //   "00" + currentTrack
                // ).slice(-2)}_jahanam_drums.mp3`}
                src={`https://fs.shegeftangizan.com/timeline-single/jahanam_voc1.mp3`}
                initialMuted={false}
                initialSolo={false}
                muteSideEffectFunction={handelMuteLED}
                soloSideEffectFunction={handelSoloSideEffects}
                announceCurrentPortion={announceCurrentPortion}
                stateChanger={changeState}
                currentTrackNumber={currentTrack}
                handelSelectionFunction={handelSelection}
                audioDestination={webAudioOutput}
                isDecorative={false}
                selected
                // waitForMe={waitForMe}
                // continueWithMe={continueWithMe}
                // trackEnded={trackEnded}
              ></UniversalControler>

              <UniversalControler
                playbackSpeed={playbackSpeed}
                layerId={layers["layer2"].id}
                layerNumber={layers["layer2"].layerNumber}
                layerPosition={layers["layer2"].layerPosition}
                mergerNodeReference={mergerNode}
                audioContextInstance={audioContextInstance}
                ref={layers["layer2"].ref}
                key={"drums"}
                name={"drums"}
                initialVolume={1}
                initialPanning={0}
                // selected
                // src={`https://fs.shegeftangizan.com/timeline-smart-tailless/${(
                //   "00" + currentTrack
                // ).slice(-2)}_jahanam_drums.mp3`}
                src={`https://fs.shegeftangizan.com/timeline-single/jahanam_drums.mp3`}
                initialMuted={false}
                initialSolo={false}
                muteSideEffectFunction={handelMuteLED}
                soloSideEffectFunction={handelSoloSideEffects}
                announceCurrentPortion={announceCurrentPortion}
                stateChanger={changeState}
                currentTrackNumber={currentTrack}
                handelSelectionFunction={handelSelection}
                audioDestination={webAudioOutput}
                isDecorative={false}
                // waitForMe={waitForMe}
                // continueWithMe={continueWithMe}
                // trackEnded={trackEnded}
              ></UniversalControler>

              <UniversalControler
                playbackSpeed={playbackSpeed}
                layerId={layers["layer3"].id}
                layerNumber={layers["layer3"].layerNumber}
                layerPosition={layers["layer3"].layerPosition}
                mergerNodeReference={mergerNode}
                audioContextInstance={audioContextInstance}
                ref={layers["layer3"].ref}
                key={"inst"}
                name={"inst"}
                initialVolume={1}
                initialPanning={0}
                // src={`https://fs.shegeftangizan.com/timeline-smart-tailless/${(
                //   "00" + currentTrack
                // ).slice(-2)}_jahanam_inst.mp3`}
                src={`https://fs.shegeftangizan.com/timeline-single/jahanam_instruments.mp3`}
                initialMuted={false}
                initialSolo={false}
                muteSideEffectFunction={handelMuteLED}
                soloSideEffectFunction={handelSoloSideEffects}
                announceCurrentPortion={announceCurrentPortion}
                stateChanger={changeState}
                currentTrackNumber={currentTrack}
                handelSelectionFunction={handelSelection}
                audioDestination={webAudioOutput}
                isDecorative={false}
                // waitForMe={waitForMe}
                // continueWithMe={continueWithMe}
                // trackEnded={trackEnded}
              ></UniversalControler>

              <UniversalControler
                playbackSpeed={playbackSpeed}
                layerId={layers["layer4"].id}
                layerNumber={layers["layer4"].layerNumber}
                layerPosition={layers["layer4"].layerPosition}
                mergerNodeReference={mergerNode}
                audioContextInstance={audioContextInstance}
                ref={layers["layer4"].ref}
                key={"BV"}
                name={"BV"}
                initialVolume={1}
                initialPanning={0}
                // src={`https://fs.shegeftangizan.com/timeline-smart-tailless/${(
                //   "00" + currentTrack
                // ).slice(-2)}_jahanam_voc_2.mp3`}
                src={`https://fs.shegeftangizan.com/timeline-single/jahanam_voc2.mp3`}
                initialMuted={false}
                initialSolo={false}
                muteSideEffectFunction={handelMuteLED}
                soloSideEffectFunction={handelSoloSideEffects}
                announceCurrentPortion={announceCurrentPortion}
                stateChanger={changeState}
                currentTrackNumber={currentTrack}
                handelSelectionFunction={handelSelection}
                audioDestination={webAudioOutput}
                // waitForMe={waitForMe}
                // continueWithMe={continueWithMe}
                // trackEnded={trackEnded}
              ></UniversalControler>

              <UniversalControler
                playbackSpeed={playbackSpeed}
                layerId={layers["layer5"].id}
                layerNumber={layers["layer5"].layerNumber}
                layerPosition={layers["layer5"].layerPosition}
                mergerNodeReference={mergerNode}
                audioContextInstance={audioContextInstance}
                ref={layers["layer5"].ref}
                key={"L5"}
                name={"L5"}
                initialVolume={1}
                initialPanning={0}
                // src={`https://fs.shegeftangizan.com/timeline-smart-tailless/${(
                //   "00" + currentTrack
                // ).slice(-2)}_jahanam_voc_2.mp3`}
                src={`https://fs.shegeftangizan.com/timeline-single/jahanam_voc2.mp3`}
                initialMuted={false}
                initialSolo={false}
                muteSideEffectFunction={handelMuteLED}
                soloSideEffectFunction={handelSoloSideEffects}
                announceCurrentPortion={announceCurrentPortion}
                stateChanger={changeState}
                currentTrackNumber={currentTrack}
                handelSelectionFunction={handelSelection}
                audioDestination={webAudioOutput}
                isDecorative={true}
                // waitForMe={waitForMe}
                // continueWithMe={continueWithMe}
                // trackEnded={trackEnded}
              ></UniversalControler>

              {/* <Grid
                item
                className={classes.gridItems}
                style={{ width: "100%", left: 5*16.5+1+"%", position: "relative",minWidth:0,minHeight:0,gridRowStart:1,gridColumnStart:1 }}
              > */}
              <Grid
                container
                direction="column"
                style={{
                  width: "15%",
                  height: "74%",
                  left: 5 * 16.5 + 1 + "%",
                  position: "relative",
                  top: 0,
                  minWidth: 0,
                  minHeight: 0,
                  gridRowStart: 1,
                  gridColumnStart: 1,
                  paddingBottom: "3%",
                }}
              >
                <Grid item container style={{ height: "11.11%" }}>
                  <Grid item className={classes.pitchBand} style={{}}></Grid>
                </Grid>

                <Grid
                  item
                  style={{
                    height: "33.33%",
                    display: "flex",
                    padding: "13% 15% 0% 35%",
                  }}
                >
                  <UpDownButton
                    value={tempo}
                    onValueChange={handelTempoChange}
                  />
                </Grid>

                <Grid
                  item
                  style={{
                    height: "33.33%",
                    display: "flex",
                    padding: "9% 15% 0% 35%",
                  }}
                >
                  <UpDownButton
                    value={transpose}
                    onValueChange={handelTransposeChange}
                  />
                </Grid>

                <Grid
                  item
                  container
                  direction="column"
                  style={{ height: "22.22%" }}
                >
                  <Grid
                    className={classes.topLayerBotton}
                    style={{ backgroundImage: `url(${exportBtn})` }}
                  ></Grid>
                  <Grid
                    className={classes.topLayerBotton}
                    style={{
                      top: "20%",
                      backgroundImage: `url(${resetBtn})`,
                    }}
                  ></Grid>
                </Grid>
              </Grid>
              {/*
              <Grid item className={classes.gridItems} style={{ width: "16.5%" }}>
                <VocalControl
                  playbackSpeed={playbackSpeed}
                  layerId={layers["layer1"].id}
                  layerNumber={layers["layer1"].layerNumber}
                  mergerNodeReference={mergerNode}
                  audioContextInstance={audioContextInstance}
                  ref={layers["layer1"].ref}
                  key={"vocal"}
                  name={"vocal"}
                  precise={false}
                  unlockDistance={0}
                  initialVolume={1}
                  initialPanning={0}
                  // src={`https://fs.shegeftangizan.com/timeline-smart-tailless/${(
                  //   "00" + currentTrack
                  // ).slice(-2)}_jahanam_voc_1.mp3`}
                  src={`https://fs.shegeftangizan.com/timeline-single/jahanam_voc1.mp3`}
                  initialMuted={false}
                  initialSolo={false}
                  muteSideEffectFunction={handelMuteLED}
                  soloSideEffectFunction={handelSoloSideEffects}
                  announceCurrentPortion={announceCurrentPortion}
                  stateChanger={changeState}
                  currentTrackNumber={currentTrack}
                  // waitForMe={waitForMe}
                  // continueWithMe={continueWithMe}
                  // trackEnded={trackEnded}
                ></VocalControl>
              </Grid> */}
            </Grid>

            <Grid item className={classes.filterBox}>
              <p>salam</p>
            </Grid>

            <Grid item className={classes.recorder}>
              <p>salam</p>
            </Grid>
          </Grid>

          <Grid
            item
            xs={4}
            container
            className={classes.RightProtraitContainer}
            style={{
              height: `${containersHeight}px`,
              paddingTop: percentOfHeight(12),
              paddingBottom: percentOfHeight(6),
            }}
          >
            {/* <LoginModal /> */}
            <Grid
              container
              direction="column"
              style={{
                height: "100%",
                width: "100%",
                // backgroundColor: "#ff000066",
              }}
            >
              <Grid
                item
                style={{ height: percentOfHeight(12), width: "100%" }}
                // style={{ height: "12%", backgroundColor: "#00ffff55" }}
              >
                <div
                  style={{
                    height: "60%",
                    top: "23%",
                    width: "42%",
                    position: "relative",
                    left: "41.8%",
                    borderRadius: "11% 11% 0% 0%",
                  }}
                >
                  <Slider
                    sx={{
                      color: "#00000000",
                      // selectionColor: "red",

                      "& .MuiSlider-thumb": {
                        backgroundImage: `url(${freqSlider})`,
                        backgroundSize: "auto 100%",
                        backgroundRepeat: "no-repeat",
                        backgroundPosition: "center",
                        stroke: 0,
                        boxShadow: "none",
                        width: "20%",
                        height: "80%",
                        borderRadius: 0,
                        "::before": {
                          boxShadow: "none",
                        },
                      },
                    }}
                    // orientation="vertical"
                    min={0}
                    max={100}
                    defaultValue={0}
                    marks={freqMarks}
                    step={null}
                    // aria-label="Temperature"
                    // valueLabelDisplay="auto"
                    // value = {volume*100}
                    // onChange={(e)=>{
                    //   handelVolumeChange(e.target.value/100)
                    // }}
                  />
                </div>
              </Grid>
              <Grid
                item
                style={{ height: "21%", padding: "4%" }}
                // style={{ height: "21%" }}
              >
                <Grid
                  Container
                  style={{
                    height: "100%",
                    paddingBottom: "5%",
                    alignSelf: "center",
                  }}
                >
                  <Grid
                    item
                    container
                    style={{ height: "50%", alignItems: "center" }}
                  >
                    <Grid item xs={6}>
                      <Typography style={{ color: "wheat" }}>
                        Frequency
                      </Typography>
                    </Grid>

                    <Grid item xs={6}>
                      <TextField
                        id="frequencyInput"
                        // label="Frequency"
                        value={`${frequency}${
                          currentTypingFocus === "frequency" && blinkingCursor
                            ? "_"
                            : ""
                        }`}
                        InputProps={{
                          readOnly: true,
                          style: { color: "#55ff55" },
                        }}
                        InputLabelProps={{
                          style: { color: "wheat" },
                        }}
                        variant="standard"
                      />
                    </Grid>
                  </Grid>
                  <Grid
                    item
                    container
                    style={{ height: "50%", alignItems: "center" }}
                  >
                    <Grid item xs={6}>
                      <Typography style={{ color: "wheat" }}>
                        Password
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        id="PasswordInput"
                        // label="Password"
                        value={`${new Array(password.length).join(
                          "*"
                        )}${password.slice(-1)}${
                          currentTypingFocus === "password" && blinkingCursor
                            ? "_"
                            : ""
                        }`}
                        InputProps={{
                          readOnly: true,
                          style: { color: "#55ff55" },
                        }}
                        InputLabelProps={{
                          style: { color: "wheat" },
                        }}
                        variant="standard"
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
              <Grid
                item
                // style={{ height: "63%", backgroundColor: "#00ffff55" }}
                style={{
                  height: "63%",
                  paddingRight: "4%",
                  paddingLeft: "3%",
                  position: "relative",
                }}
              >
                <GlassMagnifier
                  ref={keyboardRef}
                  imageSrc={ENkeyboardBaseImage}
                  imageAlt="Example"
                  largeImageSrc={ENkeyboardLargeImage} // Optional
                  magnifierSize="20%"
                  style={{
                    height: "100%",
                    display: "inline",
                    // position: "relative",
                  }}
                  callback={handelKeyboardCallback}
                  submit={hadelKeyboardSubmit}
                />
                <Dialpad
                  // canvasSize={leftContainerRef?.current?.offsetHeight * 0.1}
                  // canvasSize={parseInt(percentOfWidth(40).slice(0, -2))}
                  canvasSize={parseInt(percentOfWidth(53).slice(0, -2)) || 150}
                  style={{
                    zIndex: 100,
                    top: "23%",
                    left: percentOfWidth(23),
                    position: "absolute",
                    borderRadius: "50%",
                  }}
                  callback={(e) => {
                    console.log("dialpadCallback:", e);
                    setCurrentTypingFocus("frequency");
                    setFrequency((freq) => freq + e);
                  }}
                ></Dialpad>
              
              </Grid>
              <Grid
                item
                // style={{ height: "4%", backgroundColor: "#0000ff55" }}
                style={{ height: "4%" }}
              ></Grid>
            </Grid>
          </Grid>
        </Grid>
      </div>
      {/* 
        <Container>
          

          
          
          

          
        </Container>
      </div> */}
    </>
  );
}

export default Base;
